import PropTypes from 'prop-types'
import {
  Table, Button, Tag, Popconfirm,
} from 'antd'
import { EditTwoTone, DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import history from 'utils/history'

const SlideshowList = ({
  data, isLoading, handleDelete,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 80,
      render: (text, record, index) => (data.meta.limit * (data.meta.page - 1)) + index + 1,
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: text => text || '-',
    },
    {
      title: 'Image URL',
      dataIndex: 'image_name',
      key: 'image_name',
      ellipsis: true,
      render: text => text || '-',
    },
    {
      title: 'Video URL',
      dataIndex: 'video_url',
      key: 'video_url',
      ellipsis: true,
      render: text => text || '-',
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      ellipsis: true,
      render: text => text || '-',
    },
    {
      title: 'Order',
      dataIndex: 'order_no',
      key: 'order_no',
      render: text => text || '-',
    },
    {
      title: 'Short Description',
      dataIndex: 'short_description',
      key: 'short_description',
      render: text => text || '-',
      ellipsis: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 'active' ? 'green' : 'red'}>{text}</Tag>,
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <EditTwoTone twoToneColor="#faad14" className="mr-2" onClick={() => history.push(`/slideshow/${record.id}/edit`)} />
          <Popconfirm
            title="Are you sure delete this Slideshow?"
            okText="Yes"
            cancelText="No"
            placement="topLeft"
            onConfirm={() => handleDelete(record.id)}
          >
            <DeleteTwoTone twoToneColor="#ff4d4f" />
          </Popconfirm>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">Slideshow List</h3>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => history.push('/slideshow/add')}>
            Add Slideshow
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.list}
        loading={isLoading}
        pagination={false}
      />
    </div>
  )
}

SlideshowList.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
}

export default SlideshowList
